<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12 sm4 offset-sm4>
   			<v-card>
	   			<v-card-title>
            <v-spacer></v-spacer>
            <v-btn round color="primary" dark small class="ml-4" @click.prevent="addItem">Add New</v-btn>
            <v-dialog v-model="dialog" max-width="400px" v-if="hasCreateAccess">
              <dynamic-form v-if="dialog" :schema="formConfig" :onCancel="close" @success="processList" />
            </v-dialog>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="itemCategories"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
				      <td>{{ props.item.title }}</td>
              <td class="align-center justify-center layout px-0">
                <edit-btn :item="props.item" />
                <delete-btn :item="props.item" />
              </td>
				    </template>
				    <template slot="no-data" v-if="!processing && !itemCategories.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <action-dialog action="delete" :status="deleteDialog" @close="closeDeleteDialog" @success="deleteItem(itemCategories)" />

			</v-card>
   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>

  import DynamicForm from "../components/DynamicForm"
  import schema from "../models/ItemCategory"

  export default {
    name: 'ItemCategories',
    data () {
      return {
        model: 'itemcategory',
      	title: "Item Categories",
        validForm: false,
      	processing: false,
        dialog: false,
        deleteDialog: false,
        formConfig: this.extend(schema),
        headers: [
          { text: 'Item Category', value: 'title'},
          { text: 'Actions', value: 'id', sortable: false }
        ],
        deletingItem: null,
        rules: [
          v => !!v || 'Item Category is required',
          v => v && v.length >= 3 || 'Must be more than 2 characters',
          v => v && v.length <= 50 || 'Maximum 50 characters allowed'
        ]
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Item Categories',
	          disabled: true
	        },
	        {
	          text: 'View',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Item Categories')
    },
    methods: {

      processList (item) {
        let index = this.itemCategories.findIndex(obj => item.id === obj.id)
        index === -1 ? this.itemCategories.unshift(item) : this.itemCategories.splice(index, 1, item)
        this.setCache({ key: this.model, data: this.itemCategories })
        this.close()
      },

      addItem () {
        this.dialog = true
      },

      editItem (item) {
        this.formConfig.model = this.extend(schema.model, item)
        this.dialog = true
      },

      close () {
        this.dialog = false
        this.formConfig.model = this.extend(schema.model)
      }

    },
    mounted () {
    	this.getItemCategories()
    },

    computed: {

    },

    components: {
      'dynamic-form': DynamicForm
    }

  }
</script>
